import { render, staticRenderFns } from "./Bimface.vue?vue&type=template&id=e7c84012"
import script from "./Bimface.vue?vue&type=script&lang=js"
export * from "./Bimface.vue?vue&type=script&lang=js"
import style0 from "./Bimface.vue?vue&type=style&index=0&id=e7c84012&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports